module.exports = __webpack_public_path__ + "img/proximanovasoft-regular-webfont.b6ec00d.svg";